<div class="side-panel-container-pro">
  <div class="initial-group">
    <div class="leaflet-sidebar-tabs sidebar-tabs">
      <!-- top aligned tabs -->
      <ul role="tablist">
        <li class="map-floating-button" [class.active]="selectedTab === 'topology'">
          <a
            href="/map#topology"
            role="tab"
            (click)="selectTab('topology'); $event.preventDefault()"
            ><wlm-icon class="side-panel-icon" [icon]="'layers'" [color]="primaryColor"></wlm-icon
          ></a>
        </li>
        <li class="map-floating-button" [class.active]="selectedTab === 'thematic'">
          <a
            href="/map#thematic"
            role="tab"
            (click)="selectTab('thematic'); $event.preventDefault()"
            ><wlm-icon
              class="side-panel-icon"
              [icon]="'thematic_map'"
              [color]="primaryColor"
            ></wlm-icon
          ></a>
        </li>
        <li class="map-floating-button" *ngFor="let itemSetting of sidePanelSettings.items">
          <a
            [href]="'#' + itemSetting.id"
            role="tab"
            (click)="selectTab(itemSetting.id); $event.preventDefault()"
          >
            <wlm-icon
              class="side-panel-icon"
              [icon]="itemSetting.menuIcon"
              [color]="primaryColor"
            ></wlm-icon
          ></a>
        </li>
      </ul>

      <!-- bottom aligned tabs -->
    </div>

    <!-- panel content -->
    <div class="leaflet-sidebar-content sidebar-content">
      <div
        class="leaflet-sidebar-pane"
        id="topology"
        [style.display]="selectedTab === 'topology' ? 'block' : 'none'"
      >
        <h1 class="leaflet-sidebar-header">
          {{ T_SCOPE + '.base-layers' | translate }}
        </h1>
        <hr class="title-separator" />
        <div>
          <wlm-layers-selector
            *ngIf="topologyLayers?.length && map"
            [initialZIndex]="1000"
            [map]="map"
            [layers]="topologyLayers"
            [showLayerTypeIcon]="true"
            [isDragAndDropEnabled]="true"
            (layerItemsOrderChanged)="onTopologyLayersOrderChanged($event)"
          ></wlm-layers-selector>
        </div>
      </div>

      <div
        class="leaflet-sidebar-pane"
        id="thematic"
        [style.display]="selectedTab === 'thematic' ? 'block' : 'none'"
      >
        <div class="leaflet-sidebar-header-row">
          <h1 class="leaflet-sidebar-header">
            {{ T_SCOPE + '.thematic-maps' | translate }}
          </h1>
          <!-- <h1
            *ngIf="isOwnerOrSuperUser"
            class="leaflet-sidebar-header new-thematic-action"
            (click)="onOpenNewThematicPopup()"
            tabindex="0"
          >
            {{ T_SCOPE + '.new-thematic' | translate }}
          </h1> -->
          <button mat-icon-button *ngIf="isOwnerOrSuperUser" (click)="onOpenNewThematicPopup()">
            <wlm-icon [icon]="'add'"></wlm-icon>
          </button>
        </div>
        <hr class="title-separator" />
        <div>
          <wlm-layers-selector
            *ngIf="thematicLayers?.length && map"
            [initialZIndex]="1000"
            [map]="map"
            [layers]="thematicLayers"
            [selectedLayerItem]="layerItemSelected"
            [isDragAndDropEnabled]="true"
            [isThematic]="true"
            [canConfigure]="isOwnerOrSuperUser"
            (layerItemSelected)="onEditLayerItem($event)"
            (layerItemsOrderChanged)="onThematicLayersOrderChanged($event)"
            (layerItemDeleted)="onDeleteThematicLayer($event)"
          ></wlm-layers-selector>
        </div>
      </div>

      <!-- TODO -->

      <div
        *ngFor="let itemSetting of sidePanelSettings.items"
        class="leaflet-sidebar-pane"
        [id]="itemSetting.id"
      >
        <h1 class="leaflet-sidebar-header">
          <span class="leaflet-sidebar-close"></span>
          {{ itemSetting.titleKey | translate }}
          <wlm-icon [icon]="'drop_left'"></wlm-icon>
        </h1>
        <div>
          <ng-template mapSidePanelItemHost></ng-template>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="layerItemSelected" class="initial-group">
    <wlm-map-popup-wrapper
      [showArrowIcon]="true"
      [showSpinner]="false"
      [titleKey]="'Configuration'"
      (popupClose)="closePopup()"
    >
      <ng-container popup-content>
        <div class="popup-content">
          <div class="layer-info">
            <wlm-svg
              *ngIf="layerItemSelected.iconPath"
              class="svg-icon filter-item-option-icon"
              [style.height]="deafultSizeIcon + 'px'"
              [style.width]="deafultSizeIcon + 'px'"
              [width]="deafultSizeIcon"
              [height]="deafultSizeIcon"
              [path]="layerItemSelected.iconPath"
            ></wlm-svg>
            <span class="layer-name">{{ layerItemSelected.layerName }}</span>
          </div>
          <div class="initial-container">
            <label class="label-container">Style</label>
            <mat-form-field appearance="outline">
              <mat-select [(value)]="selectedStyleId">
                <mat-option *ngFor="let style of availableStyles" [value]="style.id">
                  {{ style.styleName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="initial-container">
            <label class="label-container">Color</label>
            <div class="color-picker-content">
              <div
                class="color-picker-type-container"
                [colorPicker]="layerItemColor"
                (colorPickerChange)="onColorPickerChange($event)"
                [style.background]="layerItemColor"
                id="colorPickerDiv"
              ></div>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  (click)="redirectColorPickerClick()"
                  [(ngModel)]="layerItemColor"
                  placeholder="Click to pick a color"
                />
              </mat-form-field>
            </div>
          </div></div
      ></ng-container>
      <ng-container popup-actions>
        <div class="popup-actions">
          <button mat-raised-button color="primary" class="save-button" (click)="applyChanges()">
            {{ 'common.apply' | translate }}
          </button>
        </div>
      </ng-container>
    </wlm-map-popup-wrapper>
  </div>
  <div *ngIf="showThematicPopup" class="initial-group scrollable-popup">
    <wlm-new-thematic-popup
      [isEditMode]="isEditThematicMode"
      [initialModel]="initialModel"
      (popupClose)="closeNewThematicPopup()"
    ></wlm-new-thematic-popup>
  </div>
</div>
